/* @flow */

import {transformDataForReport} from 'nutshell-core/json-to-report-data';
import type {ActionsObservable} from 'redux-observable';
import {Observable} from 'rxjs';
import {switchMap, map, catchError} from 'rxjs/operators';

import {updateReportChartData, failReportChartData} from './completed-actions-actions';
import type {CompletedActionsReportDataRequestedAction} from './types';

const REST_URL = '/rest/chatwidgetreports/completedactions';

export const requestCompletedActionsReportDataEpic = (action$: ActionsObservable<*>) =>
    action$.ofType('COMPLETED_ACTIONS_REPORT_DATA_REQUESTED').pipe(
        switchMap((action: CompletedActionsReportDataRequestedAction) => {
            const {reportParams, segmentBy} = action.payload;
            const params = getRequestParams(reportParams, segmentBy);
            const requestStream = Observable.from(fetchData(params));

            return requestStream.pipe(
                map(transformDataForReport),
                map((data) => data.chartData),
                map((chartData) => updateReportChartData({chartData})),
                catchError((err) => Observable.of(failReportChartData(err)))
            );
        })
    );

function fetchData(params) {
    return Promise.all([fetchReportData(params)]);
}

function getRequestParams(reportParams, segmentBy) {
    const {gap, period} = reportParams;

    const params: Object = {
        gap,
        'filter[period]': period || '-d30',
    };

    if (segmentBy) {
        params.segmentBy = segmentBy;
    }

    return params;
}

function fetchReportData(params) {
    const ajaxParams = {
        url: REST_URL,
        dataType: 'json',
        data: params,
    };

    return ($.ajax(ajaxParams): any);
}
